const facebookInitialState = {
    pageAccessToken: '',
    userToken: '',
    longLivedUserToken: '',

}
export default facebookInitialState;